<!-- ✅ ModifierParc.vue -->
<template>
  <div class="container mt-5">
    <div class="card p-4 shadow border-0" style="border-radius: 16px;">
      <h4 class="mb-4 text-dark">Edit Car</h4>

      <form @submit.prevent="handleUpdate">
        <div class="row">
          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="brand" class="form-label">Car Brand</label>
              <input type="text" class="form-control" id="brand" v-model="form.brand" required />
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="model" class="form-label">Model</label>
              <input type="text" class="form-control" id="model" v-model="form.model" required />
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="plate" class="form-label">Plate Number</label>
              <input type="text" class="form-control" id="plate" v-model="form.plate" required />
            </div>
          </div>

          <div class="col-md-6 mb-4">
            <div class="p-3 bg-white shadow-sm rounded">
              <label for="type" class="form-label">Type</label>
              <input type="text" class="form-control" id="type" v-model="form.type" required />
            </div>
          </div>
        </div>

        <div class="text-end">
          <button type="submit" class="btn text-white" style="background-color: #b03a45;">
            Save Changes
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModifierParc",
  data() {
    return {
      form: {
        brand: "",
        model: "",
        plate: "",
        type: ""
      }
    };
  },
  created() {
    // eslint-disable-next-line no-unused-vars
const id = this.$route.params.id;

    // TODO: Fetch the car using ID
    this.form = {
      brand: "Peugeot",
      model: "208",
      plate: "123-TUN-456",
      type: "Compact"
    };
  },
  methods: {
    handleUpdate() {
      alert("Car updated successfully!");
      this.$router.push("/parc");
    }
  }
};
</script>
